// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-expired-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(195, 191, 191, 0.721);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}
.subscription-expired-modal-overlay .subscription-expired-modal {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease-out;
  border: 1px solid #e2e8f0;
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-header {
  padding: 32px 32px 24px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-header .warning-icon {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-header h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.2;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body {
  padding: 32px;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body .expired-message {
  margin-bottom: 32px;
  text-align: center;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body .expired-message p {
  margin: 0;
  font-size: 16px;
  color: #4a5568;
  line-height: 1.6;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body .benefits-list h4 {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  text-align: center;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body .benefits-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body .benefits-list ul li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f7fafc;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body .benefits-list ul li:last-child {
  border-bottom: none;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-body .benefits-list ul li span {
  font-size: 15px;
  color: #4a5568;
  font-weight: 500;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer {
  padding: 24px 32px 32px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  text-align: center;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .upgrade-button-primary {
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 180px;
  justify-content: center;
  margin-bottom: 16px;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .upgrade-button-primary:hover {
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .upgrade-button-primary:active {
  transform: translateY(0);
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .logout-button-secondary {
  background: transparent;
  color: #4a5568;
  border: 2px solid #cbd5e0;
  border-radius: 10px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  margin-bottom: 12px;
  gap: 5px;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .logout-button-secondary:hover {
  background: #f7fafc;
  border-color: #a0aec0;
  color: #2d3748;
  transform: translateY(-1px);
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .logout-button-secondary:active {
  transform: translateY(0);
  background: #edf2f7;
}
.subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .upgrade-note {
  margin: 4px 0 0;
  font-size: 14px;
  color: #718096;
  font-weight: 500;
}
@media (max-width: 768px) {
  .subscription-expired-modal-overlay {
    padding: 16px;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-header {
    padding: 24px 24px 20px;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-header h2 {
    font-size: 24px;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-body {
    padding: 24px;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-body .benefits-list ul li {
    padding: 10px 0;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-body .benefits-list ul li span {
    font-size: 14px;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-footer {
    padding: 20px 24px 24px;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .upgrade-button-primary {
    padding: 10px 20px;
    font-size: 14px;
    min-width: 160px;
    margin-bottom: 14px;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .logout-button-secondary {
    padding: 9px 20px;
    font-size: 13px;
    min-width: 160px;
  }
}
@media (max-width: 480px) {
  .subscription-expired-modal-overlay .subscription-expired-modal {
    margin: 0;
    border-radius: 0;
    height: 100vh;
    max-height: 100vh;
  }
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .upgrade-button-primary,
  .subscription-expired-modal-overlay .subscription-expired-modal .modal-footer .logout-button-secondary {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionExpiredModal/SubscriptionExpiredModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AACF;AACE;EACE,6DAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;AACJ;AACI;EACE;IACE,UAAA;IACA,wCAAA;EACN;EACI;IACE,UAAA;IACA,iCAAA;EACN;AACF;AAEI;EACE,uBAAA;EACA,kBAAA;EACA,gCAAA;AAAN;AAEM;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;AAAR;AAEQ;EACE;IAEE,mBAAA;EADV;EAGQ;IACE,qBAAA;EADV;AACF;AAKM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAHR;AAOI;EACE,aAAA;AALN;AAOM;EACE,mBAAA;EACA,kBAAA;AALR;AAOQ;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AALV;AAUQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AARV;AAWQ;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AATV;AAWU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AATZ;AAWY;EACE,mBAAA;AATd;AAYY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAVd;AAiBI;EAOE,uBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EAEA,uBAAA;EACA,SAAA;EACA,kBAAA;AAtBN;AAuBM;EAEE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvBR;AAyBQ;EAEE,+CAAA;AAxBV;AA2BQ;EACE,wBAAA;AAzBV;AA6BM;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;AA3BR;AA6BQ;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;AA3BV;AA8BQ;EACE,wBAAA;EACA,mBAAA;AA5BV;AAgCM;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA9BR;AAoCE;EAzMF;IA0MI,aAAA;EAjCF;EAoCI;IACE,uBAAA;EAlCN;EAoCM;IACE,eAAA;EAlCR;EAsCI;IACE,aAAA;EApCN;EAwCU;IACE,eAAA;EAtCZ;EAwCY;IACE,eAAA;EAtCd;EA6CI;IACE,uBAAA;EA3CN;EA6CM;IACE,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EA3CR;EA8CM;IACE,iBAAA;IACA,eAAA;IACA,gBAAA;EA5CR;AACF;AAiDE;EACE;IACE,SAAA;IACA,gBAAA;IACA,aAAA;IACA,iBAAA;EA/CJ;EAkDM;;IAEE,WAAA;EAhDR;AACF","sourcesContent":[".subscription-expired-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(195, 191, 191, 0.721);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10000;\r\n  padding: 20px;\r\n\r\n  .subscription-expired-modal {\r\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n    border-radius: 16px;\r\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\r\n    max-width: 500px;\r\n    width: 100%;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n    animation: modalSlideIn 0.3s ease-out;\r\n    border: 1px solid #e2e8f0;\r\n\r\n    @keyframes modalSlideIn {\r\n      from {\r\n        opacity: 0;\r\n        transform: translateY(-20px) scale(0.95);\r\n      }\r\n      to {\r\n        opacity: 1;\r\n        transform: translateY(0) scale(1);\r\n      }\r\n    }\r\n\r\n    .modal-header {\r\n      padding: 32px 32px 24px;\r\n      text-align: center;\r\n      border-bottom: 1px solid #e2e8f0;\r\n\r\n      .warning-icon {\r\n        margin-bottom: 16px;\r\n        display: flex;\r\n        justify-content: center;\r\n        animation: pulse 2s infinite;\r\n\r\n        @keyframes pulse {\r\n          0%,\r\n          100% {\r\n            transform: scale(1);\r\n          }\r\n          50% {\r\n            transform: scale(1.1);\r\n          }\r\n        }\r\n      }\r\n\r\n      h2 {\r\n        margin: 0;\r\n        font-size: 28px;\r\n        font-weight: 700;\r\n        color: #1a202c;\r\n        line-height: 1.2;\r\n      }\r\n    }\r\n\r\n    .modal-body {\r\n      padding: 32px;\r\n\r\n      .expired-message {\r\n        margin-bottom: 32px;\r\n        text-align: center;\r\n\r\n        p {\r\n          margin: 0;\r\n          font-size: 16px;\r\n          color: #4a5568;\r\n          line-height: 1.6;\r\n        }\r\n      }\r\n\r\n      .benefits-list {\r\n        h4 {\r\n          margin: 0 0 20px;\r\n          font-size: 18px;\r\n          font-weight: 600;\r\n          color: #2d3748;\r\n          text-align: center;\r\n        }\r\n\r\n        ul {\r\n          list-style: none;\r\n          padding: 0;\r\n          margin: 0;\r\n\r\n          li {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 12px;\r\n            padding: 12px 0;\r\n            border-bottom: 1px solid #f7fafc;\r\n\r\n            &:last-child {\r\n              border-bottom: none;\r\n            }\r\n\r\n            span {\r\n              font-size: 15px;\r\n              color: #4a5568;\r\n              font-weight: 500;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .modal-footer {\r\n      // padding: 24px 32px 32px;\r\n      // text-align: center;\r\n      // border-top: 1px solid #e2e8f0;\r\n      // gap: 5px;\r\n      // display: flex;\r\n\r\n      padding: 24px 32px 32px;\r\n      border-top: 1px solid #e2e8f0;\r\n      display: flex;\r\n      flex-direction: row; \r\n      //align-items: center; /* center horizontally */\r\n      justify-content: center; \r\n      gap: 10px; \r\n      text-align: center;\r\n      .upgrade-button-primary {\r\n        //background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n        background: var(--primary-color);\r\n        color: white;\r\n        border: none;\r\n        border-radius: 10px;\r\n        padding: 12px 24px;\r\n        font-size: 15px;\r\n        font-weight: 600;\r\n        cursor: pointer;\r\n        transition: all 0.3s ease;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        //box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\r\n        min-width: 180px;\r\n        justify-content: center;\r\n        margin-bottom: 16px;\r\n\r\n        &:hover {\r\n          //transform: translateY(-2px);\r\n          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\r\n        }\r\n\r\n        &:active {\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n\r\n      .logout-button-secondary {\r\n        background: transparent;\r\n        color: #4a5568;\r\n        border: 2px solid #cbd5e0;\r\n        border-radius: 10px;\r\n        padding: 10px 24px;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        cursor: pointer;\r\n        transition: all 0.3s ease;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        min-width: 180px;\r\n        margin-bottom: 12px;\r\n        gap: 5px;\r\n\r\n        &:hover {\r\n          background: #f7fafc;\r\n          border-color: #a0aec0;\r\n          color: #2d3748;\r\n          transform: translateY(-1px);\r\n        }\r\n\r\n        &:active {\r\n          transform: translateY(0);\r\n          background: #edf2f7;\r\n        }\r\n      }\r\n\r\n      .upgrade-note {\r\n        margin: 4px 0 0;\r\n        font-size: 14px;\r\n        color: #718096;\r\n        font-weight: 500;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Mobile responsiveness\r\n  @media (max-width: 768px) {\r\n    padding: 16px;\r\n\r\n    .subscription-expired-modal {\r\n      .modal-header {\r\n        padding: 24px 24px 20px;\r\n\r\n        h2 {\r\n          font-size: 24px;\r\n        }\r\n      }\r\n\r\n      .modal-body {\r\n        padding: 24px;\r\n\r\n        .benefits-list {\r\n          ul {\r\n            li {\r\n              padding: 10px 0;\r\n\r\n              span {\r\n                font-size: 14px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .modal-footer {\r\n        padding: 20px 24px 24px;\r\n\r\n        .upgrade-button-primary {\r\n          padding: 10px 20px;\r\n          font-size: 14px;\r\n          min-width: 160px;\r\n          margin-bottom: 14px;\r\n        }\r\n\r\n        .logout-button-secondary {\r\n          padding: 9px 20px;\r\n          font-size: 13px;\r\n          min-width: 160px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    .subscription-expired-modal {\r\n      margin: 0;\r\n      border-radius: 0;\r\n      height: 100vh;\r\n      max-height: 100vh;\r\n\r\n      .modal-footer {\r\n        .upgrade-button-primary,\r\n        .logout-button-secondary {\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
